// // import store from "@/state/store";

// export default [
//   {
//     path: "/",
//     name: "dashboard",
//     meta: {
//       title: "Dashboard",
//       authRequired: true,
//     },
//     component: () => import("../router/views/Home.vue"),
//   },
//   {
//     path: "/login",
//     name: "login",
//     meta: { title: "Login" },
//     component: () => import("../router/views/account/login.vue"),
//   },
//   {
//     path: "/logout",
//     name: "logout",
//     meta: { title: "Logout" },
//     component: () => import("../router/views/account/logout.vue"),
//   },
//   {
//     path: "/auth/register",
//     name: "register",
//     meta: { title: "Register" },
//     component: () => import("../router/views/account/register.vue"),
//   },
//   {
//     path: "/auth/register-1",
//     meta: { title: "Register" },
//     component: () => import("../router/views/account/register.vue"),
//   },
//   {
//     path: "/forget-password",
//     meta: { title: "Forget Password" },
//     component: () => import("../router/views/account/forgot-password.vue"),
//   },
//   {
//     path: "/reset-password/:token", // Token as path parameter
//     meta: { title: "Reset Password" },
//     component: () => import("../router/views/account/reset-password.vue"),
//     props: (route) => ({
//       token: route.params.token,
//       email: route.query.email, // Pass email as prop from query string
//     }),
//   },
//   {
//     path: "/account/users",
//     meta: { authRequired: true, title: "Users" },
//     component: () => import("../router/views/account/users/UsersIndex.vue"),
//   },
//   {
//     path: "/account/users/add",
//     meta: { authRequired: true, title: "Users" },
//     component: () => import("../router/views/account/users/AddUser.vue"),
//   },
//   {
//     path: "/account/users/:id/edit",
//     meta: { authRequired: true, title: "Users" },
//     component: () => import("../router/views/account/users/EditUser.vue"),
//   },
//   {
//     path: "/account/roles",
//     meta: { authRequired: true, title: "Roles" },
//     component: () => import("../router/views/account/roles/Index.vue"),
//   },
//   {
//     path: "/account/roles/add",
//     meta: { authRequired: true, title: "Add Role" },
//     component: () => import("../router/views/account/roles/AddRole.vue"),
//   },
//   {
//     path: "/account/roles/:id/edit",
//     meta: { authRequired: true, title: "Edit Role" },
//     component: () => import("../router/views/account/roles/EditRole.vue"),
//   },
//   {
//     path: "/account/modules",
//     meta: { authRequired: true, title: "Modules" },
//     component: () => import("../router/views/account/modules/Index.vue"),
//   },
//   {
//     path: "/account/modules/add",
//     meta: { authRequired: true, title: "Modules" },
//     component: () => import("../router/views/account/modules/AddModule.vue"),
//   },
//   {
//     path: "/account/modules/:id/edit",
//     meta: { authRequired: true, title: "Modules" },
//     component: () => import("../router/views/account/modules/EditModule.vue"),
//   },
//   {
//     path: "/account/permissions",
//     meta: { authRequired: true, title: "Permissions" },
//     component: () => import("../router/views/account/permissions/Index.vue"),
//   },
// ];

import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("./views/account/logout"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/account/users",
    meta: { authRequired: true, title: "Users" },
    component: () => import("./views/account/users/UsersIndex.vue"),
  },
  {
    path: "/account/users/add",
    meta: { authRequired: true, title: "Users" },
    component: () => import("./views/account/users/AddUser.vue"),
  },
  {
    path: "/account/users/:id/edit",
    meta: { authRequired: true, title: "Users" },
    component: () => import("./views/account/users/EditUser.vue"),
  },
  {
    path: "/account/roles",
    meta: { authRequired: true, title: "Roles" },
    component: () => import("./views/account/roles/Index.vue"),
  },
  {
    path: "/account/license-codes",
    meta: { authRequired: true, title: "License Codes" },
    component: () => import("./views/account/license-codes/Index.vue"),
  },
  {
    path: "/account/license-codes/add",
    meta: { authRequired: true, title: "License Codes" },
    component: () => import("./views/account/license-codes/Create.vue"),
  },
  {
    path: "/account/roles/:id/edit",
    meta: { authRequired: true, title: "Edit Role" },
    component: () => import("./views/account/roles/EditRole.vue"),
  },
  {
    path: "/account/notification-setting",
    meta: { authRequired: true, title: "Notification Setting" },
    component: () => import("./views/account/NotificationSetting.vue"),
  },
  {
    path: "/settings/site",
    meta: { authRequired: true, title: "Site Settings" },
    component: () => import("./views/settings/SiteSettings.vue"),
  },
  {
    path: "/settings/email-templates",
    meta: { authRequired: true, title: "Email Templates" },
    component: () => import("./views/email-templates/Index.vue"),
  },
  {
    path: "/settings/email-templates/create",
    meta: { authRequired: true, title: "Create Email Template" },
    component: () => import("./views/email-templates/Create.vue"),
  },
  {
    path: "/settings/email-templates/:key/edit",
    meta: { authRequired: true, title: "Edit Email Template" },
    component: () => import("./views/email-templates/Edit.vue"),
  },
  {
    path: "/settings/help-module",
    meta: { authRequired: true, title: "Help Manual" },
    component: () => import("./views/settings/HelpModule.vue"),
  },
  {
    path: "/clinical/goals",
    meta: { authRequired: true, title: "Goals" },
    component: () => import("./views/clinical-setup/goals/Index.vue"),
  },
  {
    path: "/clinical/goals/add",
    meta: { authRequired: true, title: "Add Goal" },
    component: () => import("./views/clinical-setup/goals/Create.vue"),
  },
  {
    path: "/clinical/goals/:id/edit",
    meta: { authRequired: true, title: "Edit Goal" },
    component: () => import("./views/clinical-setup/goals/Edit.vue"),
  },
  {
    path: "/clinical/goals/:goalId/configuration",
    meta: { authRequired: true, title: "Goal Configuration" },
    component: () => import("./views/clinical-setup/goals/Configuration.vue"),
  },
  // Global nudge library
  {
    path: "/clinical/nudges",
    meta: { authRequired: true, title: "Nudges" },
    component: () => import("./views/clinical-setup/nudges/Index.vue"),
  },
  {
    path: "/clinical/nudges/add",
    meta: { authRequired: true, title: "Add Nudge" },
    component: () => import("./views/clinical-setup/nudges/CreateEdit.vue"),
  },
  {
    path: "/clinical/nudges/:id/edit",
    meta: { authRequired: true, title: "Edit Nudge" },
    component: () => import("./views/clinical-setup/nudges/CreateEdit.vue"),
  },
  // Goal-specific nudges
  {
    path: "/clinical/goals/:goalId/nudges",
    meta: { authRequired: true, title: "Goal Nudges" },
    component: () => import("./views/clinical-setup/goal-nudges/Index.vue"),
  },
  {
    path: "/clinical/goals/:goalId/nudges/add",
    meta: { authRequired: true, title: "Add Goal Nudge" },
    component: () =>
      import("./views/clinical-setup/goal-nudges/CreateEdit.vue"),
  },
  {
    path: "/clinical/goals/:goalId/nudges/:id/edit",
    meta: { authRequired: true, title: "Edit Goal Nudge" },
    component: () =>
      import("./views/clinical-setup/goal-nudges/CreateEdit.vue"),
  },
  {
    path: "/clinical/symptoms",
    meta: { authRequired: true, title: "Symptoms" },
    component: () => import("./views/clinical-setup/symptoms/Index.vue"),
  },
  {
    path: "/clinical/symptoms/add",
    meta: { authRequired: true, title: "Add Symptom" },
    component: () => import("./views/clinical-setup/symptoms/Create.vue"),
  },
  {
    path: "/clinical/symptoms/:id/edit",
    meta: { authRequired: true, title: "Edit Symptom" },
    component: () => import("./views/clinical-setup/symptoms/Edit.vue"),
  },
  {
    path: "/clinical/assessments",
    meta: { authRequired: true, title: "Clinical Assessments" },
    component: () => import("./views/clinical-setup/assessments/Index.vue"),
  },
  {
    path: "/clinical/assessments/add",
    meta: { authRequired: true, title: "Add Assessment" },
    component: () =>
      import("./views/clinical-setup/assessments/CreateEdit.vue"),
  },
  {
    path: "/clinical/assessments/:id/edit",
    meta: { authRequired: true, title: "Edit Assessment" },
    component: () =>
      import("./views/clinical-setup/assessments/CreateEdit.vue"),
  },
  {
    path: "/clinical/assessments/:assessmentId/questionnaires",
    meta: { authRequired: true, title: "Assessment Questionnaires" },
    component: () =>
      import("./views/clinical-setup/assessments/Questionnaires.vue"),
  },
  {
    path: "/clinical/assessment-questionnaires/:id/options",
    meta: { authRequired: true, title: "Questionnaire Options" },
    component: () =>
      import("./views/clinical-setup/assessments/QuestionnaireOptions.vue"),
  },
  {
    path: "/clinical/interventions",
    meta: { authRequired: true, title: "Interventions" },
    component: () => import("./views/clinical-setup/interventions/Index.vue"),
  },
  {
    path: "/clinical/interventions/add",
    meta: { authRequired: true, title: "Add Intervention" },
    component: () => import("./views/clinical-setup/interventions/Create.vue"),
  },
  {
    path: "/clinical/interventions/:id/edit",
    meta: { authRequired: true, title: "Edit Intervention" },
    component: () => import("./views/clinical-setup/interventions/Edit.vue"),
  },
  {
    path: "/clinical/interventions/:id/configuration",
    meta: { authRequired: true, title: "Assign Configuration" },
    component: () =>
      import("./views/clinical-setup/interventions/AssignConfiguration.vue"),
  },
  {
    path: "/clinical/interventions/filters",
    meta: { authRequired: true, title: "Filters" },
    component: () =>
      import("./views/clinical-setup/interventions/filters/Index.vue"),
  },
  {
    path: "/clinical/interventions/filters/add",
    meta: { authRequired: true, title: "Add Filter" },
    component: () =>
      import("./views/clinical-setup/interventions/filters/Create.vue"),
  },
  {
    path: "/clinical/interventions/filters/:id/edit",
    meta: { authRequired: true, title: "Edit Filter" },
    component: () =>
      import("./views/clinical-setup/interventions/filters/Edit.vue"),
  },
  {
    path: "/clinical/interventions/filters/:id/options",
    meta: { authRequired: true, title: "Manage Filter Options" },
    component: () =>
      import("./views/clinical-setup/interventions/filters/ManageOptions.vue"),
  },
  {
    path: "/clinical/interventions/categories",
    meta: { authRequired: true, title: "Intervention Categories" },
    component: () =>
      import("./views/clinical-setup/interventions/categories/Index.vue"),
  },
  {
    path: "/clinical/interventions/categories/add",
    meta: { authRequired: true, title: "Add Category" },
    component: () =>
      import("./views/clinical-setup/interventions/categories/Create.vue"),
  },
  {
    path: "/clinical/interventions/categories/:id/edit",
    meta: { authRequired: true, title: "Edit Category" },
    component: () =>
      import("./views/clinical-setup/interventions/categories/Edit.vue"),
  },
  {
    path: "/clinical/interventions/equipment",
    meta: { authRequired: true, title: "Equipment" },
    component: () =>
      import("./views/clinical-setup/interventions/equipment/Index.vue"),
  },
  {
    path: "/clinical/interventions/equipment/add",
    meta: { authRequired: true, title: "Add Equipment" },
    component: () =>
      import("./views/clinical-setup/interventions/equipment/Create.vue"),
  },
  {
    path: "/clinical/interventions/equipment/:id/edit",
    meta: { authRequired: true, title: "Edit Equipment" },
    component: () =>
      import("./views/clinical-setup/interventions/equipment/Edit.vue"),
  },
  {
    path: "/clinical/versioning",
    meta: { authRequired: true, title: "CMS Versioning" },
    component: () => import("./views/clinical-setup/versioning/Index.vue"),
  },
  // Multi-condition: conditions
  {
    path: "/conditions",
    meta: { authRequired: true, title: "Conditions" },
    component: () => import("./views/conditions/Index.vue"),
  },
  {
    path: "/conditions/add",
    meta: { authRequired: true, title: "Add Condition" },
    component: () => import("./views/conditions/CreateEdit.vue"),
  },
  {
    path: "/conditions/:id/edit",
    meta: { authRequired: true, title: "Edit Condition" },
    component: () => import("./views/conditions/CreateEdit.vue"),
  },
  // Multi-condition: shared exercise library
  {
    path: "/exercise-library",
    meta: { authRequired: true, title: "Exercise Library" },
    component: () => import("./views/exercise-library/Index.vue"),
  },
  {
    path: "/exercise-library/duplicates",
    meta: { authRequired: true, title: "Duplicate Exercises" },
    component: () => import("./views/exercise-library/Duplicates.vue"),
  },
  {
    path: "/exercise-library/:id",
    meta: { authRequired: true, title: "Exercise Usage" },
    component: () => import("./views/exercise-library/Show.vue"),
  },
  // {
  //   path: "/reset-password",
  //   name: "Reset password",
  //   component: () => import("../router/views/account/ResetPassword.vue"),
  //   meta: {
  //     authRequired: false,
  //   },
  // },
  {
    path: "/profile",
    name: "Profile",
    meta: { authRequired: true },
    component: () => import("../router/views/account/profile/Index.vue"),
  },
  {
    path: "/nationality",
    name: "Nationality",
    meta: { authRequired: true },
    component: () => import("../router/views/nationality/Index.vue"),
  },
  {
    path: "/help/faqs",
    name: "HelpFaqs",
    meta: { authRequired: true, title: "Help FAQ" },
    component: () => import("./views/help-faq/Index.vue"),
  },
  {
    path: "/help/faqs/add",
    name: "HelpFaqsAdd",
    meta: { authRequired: true, title: "Add Help FAQ" },
    component: () => import("./views/help-faq/Create.vue"),
  },
  {
    path: "/help/faqs/:id/edit",
    name: "HelpFaqsEdit",
    meta: { authRequired: true, title: "Edit Help FAQ" },
    component: () => import("./views/help-faq/Edit.vue"),
  },
  {
    path: "/help/faq-categories",
    name: "HelpFaqCategories",
    meta: { authRequired: true, title: "Help FAQ Categories" },
    component: () => import("./views/help-faq-category/Index.vue"),
  },
  {
    path: "/help/faq-categories/add",
    name: "HelpFaqCategoriesAdd",
    meta: { authRequired: true, title: "Add Help FAQ Category" },
    component: () => import("./views/help-faq-category/Create.vue"),
  },
  {
    path: "/help/faq-categories/:id/edit",
    name: "HelpFaqCategoriesEdit",
    meta: { authRequired: true, title: "Edit Help FAQ Category" },
    component: () => import("./views/help-faq-category/Edit.vue"),
  },
  {
    path: "/product-labels",
    name: "ProductLabels",
    meta: { authRequired: true, title: "Product Labels" },
    component: () => import("./views/product-labels/Index.vue"),
  },
  {
    path: "/product-labels/add",
    name: "ProductLabelsAdd",
    meta: { authRequired: true, title: "Add Product Label" },
    component: () => import("./views/product-labels/Create.vue"),
  },
  {
    path: "/product-labels/:id/edit",
    name: "ProductLabelsEdit",
    meta: { authRequired: true, title: "Edit Product Label" },
    component: () => import("./views/product-labels/Edit.vue"),
  },
  {
    path: "/contact-supports",
    name: "ContactSupports",
    meta: { authRequired: true, title: "Contact Supports" },
    component: () => import("./views/contact-support/Index.vue"),
  },
  {
    path: "/contact-supports/:id",
    name: "ContactSupportShow",
    meta: { authRequired: true, title: "Contact Support Detail" },
    component: () => import("./views/contact-support/Show.vue"),
  },
  {
    path: "/contact-supports/categories",
    name: "ContactSupportCategories",
    meta: { authRequired: true, title: "Contact Support Categories" },
    component: () => import("./views/contact-support-category/Index.vue"),
  },
  {
    path: "/contact-supports/categories/add",
    name: "ContactSupportCategoriesAdd",
    meta: { authRequired: true, title: "Add Contact Support Category" },
    component: () => import("./views/contact-support-category/Create.vue"),
  },
  {
    path: "/contact-supports/categories/:id/edit",
    name: "ContactSupportCategoriesEdit",
    meta: { authRequired: true, title: "Edit Contact Support Category" },
    component: () => import("./views/contact-support-category/Edit.vue"),
  },
  {
    path: "/tracker",
    meta: { authRequired: true, title: "Tracker" },
    component: () => import("./views/tracker/Index.vue"),
  },
  {
    path: "/tracker/:id/configuration",
    name: "tracker-configuration",
    component: () => import("@/router/views/tracker/Configuration.vue"),
    meta: {
      requiresAuth: true,
      title: "Tracker Configuration",
    },
  },
  {
    path: "/report/monthly",
    meta: { authRequired: true, title: "Reports" },
    component: () => import("./views/report/MonthlyReport.vue"),
  },
  {
    path: "/report/user-data-dumps",
    meta: { authRequired: true, title: "User Data Dumps" },
    component: () => import("./views/report/UserDataDumps.vue"),
  },
  {
    path: "/report/patients/:user/reports",
    meta: { authRequired: true, title: "Patient Reports" },
    component: () => import("./views/report/PatientReports.vue"),
  },
  {
    path: "/report/reports/:userReport",
    meta: { authRequired: true, title: "Report Detail" },
    component: () => import("./views/report/ReportDetail.vue"),
  },
  {
    path: "/report/quotes",
    meta: { authRequired: true, title: "Quotes" },
    component: () => import("./views/report/quotes/Index.vue"),
  },
  {
    path: "/report/quotes/add",
    meta: { authRequired: true, title: "Add Quote" },
    component: () => import("./views/report/quotes/CreateEdit.vue"),
  },
  {
    path: "/report/quotes/:id/edit",
    meta: { authRequired: true, title: "Edit Quote" },
    component: () => import("./views/report/quotes/CreateEdit.vue"),
  },
  // Legal
  {
    path: "/legal/consent-versions",
    meta: { authRequired: true, title: "Consent Versions" },
    component: () => import("./views/legal/ConsentVersions.vue"),
  },
  // Engagement Management Routes
  {
    path: "/engagement/rules",
    meta: { authRequired: true, title: "Engagement Rules" },
    component: () => import("./views/engagement-management/rules/Index.vue"),
  },
  {
    path: "/engagement/rules/add",
    meta: { authRequired: true, title: "Add Engagement Rule" },
    component: () => import("./views/engagement-management/rules/Create.vue"),
  },
  {
    path: "/engagement/rules/:id/edit",
    meta: { authRequired: true, title: "Edit Engagement Rule" },
    component: () => import("./views/engagement-management/rules/Edit.vue"),
  },
  // {
  //   path: "/tracker/add",
  //   meta: { authRequired: true, title: "Add Tracker" },
  //   component: () => import("./views/tracker/Create.vue"),
  // },
  // {
  //   path: "/tracker/:id/edit",
  //   meta: { authRequired: true, title: "Edit Tracker" },
  //   component: () => import("./views/tracker/Edit.vue"),
  // },
  // Developer-only tooling. Deliberately not added to components/menu.js —
  // reachable only by typing the URL directly while logged in as Admin.
  {
    path: "/dev/reminders-log",
    name: "reminders-log",
    meta: { authRequired: true, title: "Reminders Log" },
    component: () => import("./views/dev/RemindersLog.vue"),
  },
];
